import styled from "styled-components";

export const Wrapper = styled.div`
  text-align: center;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const Container = styled.div`
  width: 100%;
  padding: 0 10px;
  margin: 0 auto;
  position: relative;
`;

export const Content = styled.div`
  @media screen and (max-width: 576px) {
    padding-bottom: 41px;
  }
`;

export const MainTitle = styled.h3`
  font-size: 40px;
  font-weight: 500;
  margin-bottom: 20px;
  font-family: AeonikMedium !important;

  @media screen and (max-width: 576px) {
    font-size: 30px;
  }
`;

export const Title = styled.h3`
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  font-family: AeonikMedium !important;
  line-height: 39px;
  margin-bottom: 15px;
  color: #1e2329;
  text-align: left;
`;
export const Desc = styled.p`
  font-weight: 300;
  font-size: 16px;
  text-align: justify;
  font-family: AeonikRegular !important;
  .bold{
    font-weight: 600;
  }
`;

